const GUIDE = [
  ["Jeté", "Canapé, fauteuil ou pied de lit"],
  ["Lit simple", "Lit simple (39 po / 99 cm de large)"],
  ["Lit double", "Lit double (54 po / 137 cm de large)"],
  ["Grand lit", "Grand lit / Queen (60 po / 152 cm de large)"],
  ["Très grand lit", "Très grand lit / King (76 po / 193 cm de large)"],
];

const bedFor = (size) => (GUIDE.find(([k]) => size.startsWith(`${k} `)) || [])[1];

export function SizeGuide({ sizes }) {
  const rows = sizes.map((s) => [s, bedFor(s)]).filter(([, b]) => b);
  if (!rows.length) return null;
  return (
    <details className="mt-4 border-t border-black/10 pt-3 text-sm group" data-testid="size-guide">
      <summary className="cursor-pointer label-xs list-none flex justify-between" data-testid="size-guide-toggle">Guide des tailles <span className="transition-transform duration-200 group-open:rotate-45">+</span></summary>
      <table className="w-full mt-3 text-left">
        <thead><tr className="text-xs text-muted-foreground"><th className="py-1.5 font-normal">Format</th><th className="py-1.5 font-normal">Convient à</th></tr></thead>
        <tbody>{rows.map(([s, b]) => <tr key={s} className="border-t border-black/5"><td className="py-2 pr-3 whitespace-nowrap">{s}</td><td className="py-2 text-muted-foreground">{b}</td></tr>)}</tbody>
      </table>
      <p className="text-xs text-muted-foreground mt-2">Pour un tombé généreux sur les côtés, choisissez le format au-dessus de votre lit.</p>
    </details>
  );
}
